import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=275fe5a6"
import script from "./newsList.vue?vue&type=script&lang=ts"
export * from "./newsList.vue?vue&type=script&lang=ts"
import style0 from "./newsList.vue?vue&type=style&index=0&id=275fe5a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports